/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section1_P1Inputs */

const en_terms_section1_p1 = /** @type {(inputs: Terms_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By accessing and using PureJSON (purejson.org), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use the service.`)
};

const ko_terms_section1_p1 = /** @type {(inputs: Terms_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON(purejson.org)에 접속하고 사용함으로써 본 이용약관에 동의하게 됩니다. 약관의 일부에 동의하지 않는 경우 서비스를 사용하지 마십시오.`)
};

const ja_terms_section1_p1 = /** @type {(inputs: Terms_Section1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON（purejson.org）にアクセスし使用することにより、本利用規約に同意したものとみなされます。これらの規約のいずれかに同意しない場合は、サービスを使用しないでください。`)
};

/**
* | output |
* | --- |
* | "By accessing and using PureJSON (purejson.org), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do ..." |
*
* @param {Terms_Section1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section1_p1 = /** @type {((inputs?: Terms_Section1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section1_p1(inputs)
	if (locale === "ko") return ko_terms_section1_p1(inputs)
	return ja_terms_section1_p1(inputs)
});